
/**
 * The product's name and mark, in one place.
 *
 * ContactPilot is the customer-facing name. Internal identifiers — package names, the
 * database, environment variables, the session cookie, OAuth registrations and the
 * `Inbox Signal/…` labels already created in customers' mailboxes — keep the old name on
 * purpose; docs/contactpilot/brand-migration.md lists each one and why.
 *
 * The mark is a placeholder drawn for this build, not final production artwork.
 */
export const PRODUCT_NAME = 'ContactPilot';
export const COMPANY_NAME = 'ROI Pros';

/**
 * A white paper plane on the brand-blue tile: the mark at small sizes and as the favicon.
 * Flat #1677F2, as the owner's brand sheet shows it (2026-11-03). A flat fill also needs
 * no per-instance gradient id, which once made the tile vanish when the first copy was hidden.
 */
export function LogoMark({ size = 32 }: { size?: number }) {
  return (
    <svg aria-hidden="true" focusable="false" width={size} height={size} viewBox="0 0 32 32">
      <rect width="32" height="32" rx="9" fill="#1677F2" />
      <path d="M7.5 15.6 24.2 8.4c.6-.3 1.2.3.9.9l-7.1 16.8c-.3.7-1.3.6-1.5-.1l-1.6-5.6a1 1 0 0 0-.6-.6l-5.7-1.7c-.7-.2-.8-1.2-.1-1.5Z" fill="#fff" />
      <path d="m14.8 19.9 4.6-6.2" stroke="#1677F2" strokeWidth="1.4" strokeLinecap="round" />
    </svg>
  );
}

/** Mark plus wordmark. `compact` drops the wordmark for the narrowest headers. */
export function Logo({ compact = false, size = 32 }: { compact?: boolean; size?: number }) {
  return (
    <span className="inline-flex items-center gap-2">
      <LogoMark size={size} />
      {compact ? <span className="sr-only">{PRODUCT_NAME}</span> : (
        <span className="text-lg font-bold tracking-tight text-cp-navy">
          Contact<span className="text-cp-blue-600">Pilot</span>
        </span>
      )}
    </span>
  );
}
